import axios from "axios";
import {IRegisterFormValues} from "../../../pages/auth/register/i-register";
import {API_BASE_URL_V2} from "../../../services/config";
import {
  getSignupTrackingParams,
  clearSignupTrackingData,
} from "../../../utils/signup-tracking";

// Register standard user
export const registerStandardUserService = async (userData: IRegisterFormValues) => {
  const payload = {
    ...userData,
    isSocialAuth: false,
  };

  // POST /auth/standard
  const trackingParams = getSignupTrackingParams();
  const response = await axios.post(API_BASE_URL_V2 + "auth/standard", payload, {
    params: trackingParams,
  });
  clearSignupTrackingData();
  return response.data;
};
